var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: "save-template-email-modal",
      "modal-dialog-scrollable": false,
      "footer-close-button": false,
      "loaders-disabled": "",
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHide },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _c(
              "h5",
              {
                staticClass:
                  "modal-title bold d-flex align-items-center w-100 mb-0",
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.loadedTemplate && !_vm.saveAsNew
                        ? _vm.$t("email.updateEmailTemplate")
                        : _vm.$t("email.saveCurrentEmailAsTemplate")
                    ) +
                    "\n      "
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white ml-auto",
                    attrs: {
                      type: "button",
                      disabled: _vm.uploadingAttachment,
                    },
                    on: { click: _vm.openAttachmentPicker },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.uploadingAttachment
                            ? _vm.$t("global.phrases.loading")
                            : _vm.$t("email.uploadAttachment")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "form",
              {
                attrs: { id: "timeline-save-email-form" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    name: "name",
                    placeholder: _vm.$t("templates.templateName"),
                    label: _vm.$t("templates.templateName"),
                  },
                  model: {
                    value: _vm.templateName,
                    callback: function ($$v) {
                      _vm.templateName = $$v
                    },
                    expression: "templateName",
                  },
                }),
                _vm._v(" "),
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    name: "description",
                    placeholder: _vm.$t("global.words.description"),
                    label: _vm.$t("global.words.description"),
                  },
                  model: {
                    value: _vm.templateDescription,
                    callback: function ($$v) {
                      _vm.templateDescription = $$v
                    },
                    expression: "templateDescription",
                  },
                }),
                _vm._v(" "),
                _c("material-input", {
                  attrs: {
                    value: _vm.subject,
                    "validator-context": _vm.$v,
                    name: "subject",
                    placeholder: _vm.$t("global.words.subject"),
                    label: _vm.$t("global.words.subject"),
                  },
                  on: {
                    input: function (value) {
                      return (_vm.templateSubject = value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "html" },
                  domProps: { value: _vm.html },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group-material" }, [
              _c(
                "label",
                { staticClass: "title text-light-gray mb-2 mb-lg-0" },
                [_vm._v(_vm._s(_vm.$t("global.words.preview")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "rich-text-editor--reset mt-5",
              attrs: { id: "save-email-preview" },
              domProps: { innerHTML: _vm._s(_vm.html) },
            }),
            _vm._v(" "),
            _c("input", {
              ref: "attachmentInput",
              staticClass: "d-none",
              attrs: {
                type: "file",
                accept:
                  "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg,application/x-rar-compressed,application/octet-stream,application/zip,application/x-zip-compressed,multipart/x-zip",
              },
              on: { change: _vm.handleAttachmentUpload },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function (ref) {
          var close = ref.close
          return [
            _vm.displayedAttachments.length > 0
              ? _c("div", { staticClass: "horizontal-scrollable w-100 mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "d-inline-flex align-items-center" },
                    [
                      _c("span", { staticClass: "text-light-gray mr-3" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("email.attachments")) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-items-center flex-nowrap",
                        },
                        _vm._l(
                          _vm.displayedAttachments,
                          function (attachment, index) {
                            return _c(
                              "div",
                              {
                                key: attachment.fileName || index,
                                staticClass:
                                  "btn btn-white btn-sm d-inline-flex align-items-center mr-2 mb-0",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-truncate",
                                    staticStyle: { "max-width": "180px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(attachment.fileName) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link btn-sm text-danger p-0 ml-2",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Remove attachment",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeAttachment(index)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-times",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-end align-items-center w-100",
              },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "cancel-modal btn-sm mr-2",
                    attrs: { variant: "white" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.words.close")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "simple-button",
                  {
                    attrs: {
                      loading: _vm.savingTemplate,
                      disabled: !_vm.isValid || _vm.uploadingAttachment,
                    },
                    on: { click: _vm.saveTemplate },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.loadedTemplate && !_vm.saveAsNew
                            ? _vm.$t("global.words.update")
                            : _vm.$t("documents.saveAsTemplate")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }